import styled from "styled-components";
import type { InrixVolumeFeature } from "../../../map/views/OrderItem/InrixVolumes/models/InrixVolumeFeature";
import useGetOrderItemInrixVolumeParams, {
  InrixVolumeTimePeriod,
} from "../../../map/views/OrderItem/InrixVolumes/controls/GetOrderItemInrixVolumeParams";
import { getInrixVolumeFeatureValue } from "../../../map/views/OrderItem/InrixVolumes/utils/getInrixVolumeFeatureValue";
import { formatTimePeriodRangeLabel } from "../../../map/views/OrderItem/InrixVolumes/utils/formatSegmentLabel";
import { useThemeContext } from "../../../theme/ThemeContext";
import { Theme } from "../../../../constant/Theme";
import { formatDayOfWeek } from "../../../../utils/formatDayOfWeek";

interface InrixVolumeSidebarHeaderProps {
  model: InrixVolumeFeature;
  timePeriod: InrixVolumeTimePeriod;
  timeSegment: number | null;
  timeIndex: number | null;
}

const HeaderWrapper = styled.div<{ $isDark: boolean }>`
  width: 100%;
  text-align: center;
  padding-bottom: 0.75rem;
  margin-bottom: 0.75rem;
  border-bottom: 1px solid ${({ $isDark }) => ($isDark ? "#ffffff" : "#555555")};
`;

const getTitle = (
  timePeriod: InrixVolumeTimePeriod,
  timeSegment: number | null,
): string => {
  if (timePeriod === InrixVolumeTimePeriod.ADT) {
    return "ADT";
  }
  if (timeSegment !== null) {
    return formatTimePeriodRangeLabel(timeSegment);
  }
  return "15 mins";
};

const InrixVolumeSidebarHeader = ({
  model,
  timePeriod,
  timeSegment,
  timeIndex,
}: InrixVolumeSidebarHeaderProps) => {
  const { theme } = useThemeContext();
  const isDark = theme === Theme.DARK;
  const title = getTitle(timePeriod, timeSegment);
  const value = getInrixVolumeFeatureValue(model, timePeriod, timeIndex);
  const { dayOfWeek } = useGetOrderItemInrixVolumeParams();
  const formattedDayOfWeek = formatDayOfWeek(dayOfWeek);
  return (
    <HeaderWrapper $isDark={isDark}>
      <h5 className="mb-1">
        {" "}
        {formattedDayOfWeek !== null ? `${formattedDayOfWeek} ` : ""}
        {title}
      </h5>
      <p className="mb-0 fs-4 fw-semibold">
        {value !== null ? value.toLocaleString() : "—"}
      </p>
    </HeaderWrapper>
  );
};

export default InrixVolumeSidebarHeader;
